<template>
  <f7-page no-swipeback ref="page">
    <f7-navbar title="商品列表 Product List" back-link="返回 Back"></f7-navbar>

    <f7-searchbar
      placeholder="搜尋商品 Search Products"
      :clear-button="true"
      :value="searchQuery"
      @input="onSearch"
      style="margin-top: 44px;"
    ></f7-searchbar>

    <f7-toolbar tabbar scrollable position="top">
      <f7-link tab-link :tab-link-active="current_root_category_id === 0" :key="0" @click="() => changeCategory(0)">全部 All</f7-link>
      <f7-link tab-link :tab-link-active="current_root_category_id === category.id" :key="category.id" v-for="category in categories" @click="() => changeCategory(category.id)">{{ category.name }}</f7-link>
    </f7-toolbar>

    <f7-list media-list virtual-list ref="list">
      <f7-list-group :key="category.category_id" v-for="category in filteredCategoriesProducts">
        <f7-list-item :title="category.category_name" group-title></f7-list-item>
        <f7-list-item
          v-for="product in category.products"
          :key="product.id"
          :title="product.name"
          class="text-orange"
        >
          <list-product-item
            :product="product"
            @updated="(quantity) => handleQuantityChanged(category.category_id, product.id, quantity)"
            @updated-order-product-inventory-quantity="({inventory, quantity}) => handleOrderProductInventoryQuantityChanged(category.category_id, product.id, inventory.id, quantity)"
          />
        </f7-list-item>
      </f7-list-group>
    </f7-list>

    <f7-toolbar position="bottom">
      <div class="bottom-overview" style="font-size: 15px">
        {{ totalProductsCount }} 項 Items，{{ totalProductsQuantity }} 件 Quantity
        <br>合計 Total ${{ subtotal }}
      </div>
      <f7-link @click="confirmOrder">下一步 Next</f7-link>
    </f7-toolbar>
  </f7-page>
</template>

<script>
import axios from 'axios'
import ListProductItem from './ListProductItem.vue'

export default {
  components: {
    ListProductItem,
  },

  data() {
    return {
      categories: [],
      categories_products: [],
      current_root_category_id: 1,
      searchQuery: '',
    }
  },

  mounted() {
    let categories_draft = JSON.parse(localStorage.getItem('categories_draft'))
    let categories_products_draft = JSON.parse(localStorage.getItem('categories_products_draft'))

    if (categories_draft) {
      this.categories = categories_draft
    } else {
      axios.get('/api/categories').then(({ data }) => {
        this.categories = data
      })
    }

    if (categories_products_draft) {
      this.categories_products = categories_products_draft
    } else {
      axios.get('/api/products').then(({ data }) => {
        let subCategories = [...new Set(data.map(product => product.category.id))];

        let structured = subCategories.map((category_id) => {
          let categoryFound = data.find(obj => obj.category.id === category_id)

          return {
            category_id: category_id,
            category_name: categoryFound.category.name,
            products: data.filter((item) => {
              return item.category.id === category_id
            }).map((product) => {
              return {
                id: product.id,
                name: product.name,
                quantity: 0,
                price: (product.price / 100),
                features: [], // product.properties
                manages_inventory: product.manages_inventory,
                inventories: product.inventories.map(inventory => ({
                  ...inventory,
                  order_quantity: 0,
                })),
              }
            })
          }
        })

        this.categories_products = structured
      })
    }
  },

  computed: {
    totalProductsCount() {
      return this.categories_products.reduce((accumulator, category) => {
        return category.products.reduce((total, product) => {
          if (product.quantity > 0) {
            return total + 1;
          }
          if (product.inventories.find(inventory => (inventory.order_quantity > 0))) {
            return total + 1;
          }
          return total
        }, accumulator)
      }, 0)
    },
    totalProductsQuantity() {
      return this.categories_products.reduce((accumulator, category) => {
        return category.products.reduce((amount, product) => {
          return amount + product.quantity
        }, accumulator)
      }, 0)
    },
    subtotal() {
      return this.categories_products.reduce((accumulator, category) => {
        return category.products.reduce((total, product) => {
          return total + (product.quantity * product.price)
        }, accumulator)
      }, 0)
    },
    filteredCategoriesProducts() {
      // Handle empty data
      if (this.categories.length === 0 || this.categories_products.length === 0) {
        return []
      }

      let filtered = [...this.categories_products]

      // Filter by search query if exists
      if (this.searchQuery && typeof this.searchQuery === 'string' && this.searchQuery.trim() !== '') {
        const searchTerm = this.searchQuery.toLowerCase().trim()
        filtered = filtered.map(category => ({
          ...category,
          products: category.products.filter(product => 
            product.name.toLowerCase().includes(searchTerm)
          )
        })).filter(category => category.products.length > 0)
      }

      // Filter by category if not showing all
      if (this.current_root_category_id !== 0) {
        const currentCategory = this.categories.find(root => root.id === this.current_root_category_id);
        const subcategories = currentCategory?.subcategories || [];
        
        // Create a map of subcategory IDs in their sorted order
        const subcategoryOrder = new Map(subcategories.map((subcat, index) => [subcat.id, index]));
        
        filtered = filtered.filter(category_products => 
          subcategoryOrder.has(category_products.category_id)
        );
        
        // Sort filtered categories based on the original subcategory order
        filtered.sort((a, b) => {
          return subcategoryOrder.get(a.category_id) - subcategoryOrder.get(b.category_id);
        });
      }

      return filtered
    },
  },

  methods: {
    handleQuantityChanged(category_id, product_id, quantity) {
      let data = JSON.parse(JSON.stringify(this.categories_products))
      let category = data.find((element) => element.category_id === category_id)
      let product = category.products.find((product) => product.id === product_id)
      product.quantity = quantity

      this.categories_products = data
    },
    handleOrderProductInventoryQuantityChanged(categoryId, productId, inventoryId, quantity) {
      let data = JSON.parse(JSON.stringify(this.categories_products))
      let category = data.find((element) => element.category_id === categoryId)
      let product = category.products.find((product) => product.id === productId)
      let inventory = product.inventories.find((inventory) => inventory.id === inventoryId)
      inventory.order_quantity = quantity

      this.categories_products = data
    },
    confirmOrder() {
      localStorage.setItem('categories_draft', JSON.stringify(this.categories))
      localStorage.setItem('categories_products_draft', JSON.stringify(this.categories_products))

      let data = JSON.parse(JSON.stringify(this.categories_products)).filter((category) => {
        category.products = category.products.filter((product) => {
          if (product.quantity > 0) {
            return true
          }
          if (product.inventories.find(inventory => (inventory.order_quantity > 0))) {
            return true
          }
          return false
        })

        return category.products.length > 0
      })

      if (data.length === 0) return

      this.$f7router.navigate('/store/order/confirm/', { props: { data } })
    },
    changeCategory(category_id) {
      this.current_root_category_id = category_id

      this.$nextTick(() => {
        this.$$(this.$refs['page'].$el).find('.page-content')[0].scrollTop = 0
      })
    },
    onSearch(e) {
      this.searchQuery = e.target.value
    },
  }
}
</script>
